import React from 'react'

export const DialogContext = React.createContext({})

export const DialogProvider = ({ value = {}, children }) => {
  return (
    <DialogContext.Provider value={value}>{children}</DialogContext.Provider>
  )
}

export const useDialog = () => {
  const context = React.useContext(DialogContext)

  if (context === null) {
    throw new Error('Attempted to call useDialog outside the Dialog component.')
  }

  return context
}
